

// working code for otp and image view and 
import React, { useEffect, useState } from "react";
import { Card, Row, Col, Modal, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  getRoList,
  sendRoOTP,
  validateRoOTP,
} from "../../../Service/AllRoOnboardingAPI";

const RoOnboardingTable = () => {
  const [entries, setEntries] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // Modal states for image preview
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);

  // Modal states for OTP
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [smsOtp, setSmsOtp] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [sendingOtpForId, setSendingOtpForId] = useState(null);

  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpSendMessage, setOtpSendMessage] = useState("");
  const [otpVerifyMessage, setOtpVerifyMessage] = useState("");
  const [otpVerified, setOtpVerified] = useState(null);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
const [otpDisabled, setOtpDisabled] = useState(false);
const [otpTimer, setOtpTimer] = useState(60);



  useEffect(() => {
    const role = sessionStorage.getItem("role");
    const userId = sessionStorage.getItem("pkUserId");

    if (!role || !userId) {
      console.error("Missing role or userId");
      return;
    }

    getRoList(userId, role)
      .then((res) => {
        const data = res.data;
        let dataArray = [];

        if (Array.isArray(data)) dataArray = data;
        else if (data && Array.isArray(data.data)) dataArray = data.data;
        else console.error("API response not array:", data);

        // setEntries(dataArray);
        dataArray.sort((a, b) => b.roId - a.roId);
        setEntries(dataArray);
      })
      .catch((err) => {
        console.error("Error fetching RO Onboarding data", err);
      });
  }, []);


  useEffect(() => {
  if (!otpDisabled) return;

  const timer = setInterval(() => {
    setOtpTimer((prev) => {
      if (prev <= 1) {
        clearInterval(timer);
        setOtpDisabled(false);
        return 60;
      }
      return prev - 1;
    });
  }, 1000);

  return () => clearInterval(timer);
}, [otpDisabled]);


  // Filter entries by search text
  const filteredEntries = entries.filter(
    (entry) =>
      entry.roName?.toLowerCase().includes(searchText.toLowerCase()) ||
      entry.contactPerson?.toLowerCase().includes(searchText.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredEntries.length / rowsPerPage);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentEntries = filteredEntries.slice(indexOfFirst, indexOfLast);

  const clearSearch = () => {
    setSearchText("");
    setSearchPerformed(false);
    setCurrentPage(1);
  };

  const handleSearch = () => {
    setSearchPerformed(true);
    setCurrentPage(1);
  };


  const handleImageClick = (imageData) => {
    if (!imageData) return;

    if (imageData.startsWith("data:image")) {
      setSelectedImageUrl(imageData);
      setShowImageModal(true);
    } else {
      console.error("Invalid Base64 image format:", imageData);
    }
  };



  const sendOtp = (entry) => {
    setOtpSendMessage("");
    setOtpVerifyMessage("");
    setSmsOtp("");
    setEmailOtp("");
    setCurrentEntry(entry);
    setShowOtpModal(true);
  };


  const triggerOtpSend = async () => {
    setOtpSendMessage("");
    setSendingOtpForId(currentEntry.roId);

    try {
      await sendRoOTP({
        email: currentEntry.roEmail,
        mobile: currentEntry.roContact,
      });

      setOtpSendMessage("OTP sent successfully!");
     setOtpDisabled(true);
     setOtpTimer(60);
    } catch (error) {
      const errMsg = error.response?.data?.message || error.message || "Failed to send OTP";
      setOtpSendMessage(errMsg);
    } finally {
      setSendingOtpForId(null);
    }
  };

  // Verify OTP
  const verifyOtp = async () => {
    setOtpVerifyMessage("");
    setOtpVerified(null);

    if (!smsOtp || !emailOtp) {
      setOtpVerifyMessage("Please enter both SMS OTP and Email OTP");
      setOtpVerified(false);
      return;
    }

    try {
      setOtpVerifying(true);

      const res = await validateRoOTP({
        mobileNumber: currentEntry.roContact,
        smsOtp,
        email: currentEntry.roEmail,
        emailOtp,
      });

      const result = res.data;

      if (result.verified) {
        setOtpVerified(true);
        setOtpVerifyMessage("OTP Verified Successfully!");

        setTimeout(() => {
          setShowOtpModal(false);
          setOtpVerifyMessage("");
          setOtpVerified(null);
          setCurrentEntry(null);
          setSmsOtp("");
          setEmailOtp("");
         window.location.href = '/Callcenter/RoGetlist';
        }, 6000);
      } else {
        setOtpVerified(false);
        setOtpVerifyMessage(result.message || "OTP verification failed");
      }
    } catch (error) {
      setOtpVerified(false);
      const errMsg = error.response?.data?.message || error.message || "OTP verification failed";
      setOtpVerifyMessage(errMsg);
    } finally {
      setOtpVerifying(false);
    }
  };

  const imageFieldFormatter = (cell) =>
    cell && cell.startsWith("data:image") ? (
      <Button
        variant="primary"
        size="md"
        onClick={() => handleImageClick(cell)}
        style={{ padding: 4 }}
      >
        View Image
      </Button>
    ) : (
      "Upload image"
    );

    const renderTableTooltip = (text, maxLength = 25) => {
  if (!text) return "-";

  return (
    <div className="table-tooltip">
      <span>
        {text.length > maxLength ? text.substring(0, maxLength) + "..." : text}
      </span>

      {text.length > maxLength && (
        <span className="table-tooltip-text">{text}</span>
      )}
    </div>
  );
};


  return (
    <div className="mt-4">
      <Card>
        <Col xs={12} md={6} className="p-2">
          <h5 className="head">RO Onboarding List</h5>
        </Col>
        <Card.Header>
          <Row>



            <Col xs={12} md={6} className="py-1 d-flex ">

              <input
                type="search"
                placeholder="Search by RO Name or Contact Person..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="form-control-alternative form-control searchinput "
                style={{ marginRight: '10px' }}
              />

              {/* <button className="btn btn-secondary" onClick={searchPerformed ? clearSearch : handleSearch}>
          <FontAwesomeIcon icon={searchPerformed ? faTimes : faSearch} className="me-2" />
          <span>{searchPerformed ? "Clear" : "Search"}</span>
        </button> */}
            </Col>
            {role === "admin" || role === "tech person" ? (
              <Col
                xs={12}
                md={6}
                className="d-flex justify-content-md-end py-1"
              >
                <div className="newadd" align="right">
                  <Link to="ROCreate" className="btn btn-secondary">
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Create New RO
                  </Link>
                </div>
              </Col>
            ) : (
              ""
            )}
          </Row>
        </Card.Header>

        <div className="table-responsive py-2">
          <table className="table table-striped table-hover">
            <thead className="table-green">
              <tr>
                <th>RO ID</th>
                <th>RO Code</th>
                <th>RO Name</th>
                <th>Ro manager name</th>
                <th>RO manager Email</th>
                <th>RO manager contact number</th>

                {/* <th>Actions</th>
              <th>Send OTP</th> */}


                {(role === "tech person" || role === "admin") ? (
                  <>
                    <th>Actions</th>
                    <th>Validate OTP</th>
                  </>
                ) : (
                  ""
                )}


                <th>Dispensers</th>
                <th>Country</th>
                <th>State</th>
                 <th>District</th>
                <th>City</th>
                <th>Address</th>
                <th>Pincode</th>
                <th>Alt. Email</th>
                <th>Alt. Contact</th>
                <th>Alt. Contact Person</th>
                {/* <th>Latitude</th>
              <th>Longitude</th> */}
                <th>incorporation Certificate</th>
                <th>GST Certificate</th>
                <th>PAN Card</th>
                <th>Contact Aadhaar</th>
                <th>Alt. Aadhaar</th>
                <th>Created Date</th>
                <th>Updated Date</th>
                <th>Ro Remark</th>
                <th>Doc Validation</th>
                <th>Status</th>
                <th>Customer</th>
                <th>RO Status</th>
                <th>Created By</th>
                <th>Updated By</th>
              </tr>
            </thead>
            <tbody>
              {currentEntries.length > 0 ? (
                currentEntries.map((entry, index) => (
                  <tr key={index || entry.roName}>
                    <td>{indexOfFirst + index + 1}</td>
                    <td>{entry.roCode}</td>
                    <td>{entry.roName}</td>
                    <td>{entry.contactPerson}</td>
                    <td>{entry.roEmail}</td>
                    <td>{entry.roContact}</td>




                    {(role === "tech person" || role === "admin") ? (
                      <>
                        <td>
                          <Link
                            to={{
                              pathname: "/Callcenter/ROCreate",
                              state: { roData: entry },
                            }}
                            className="btn btn-sm btn-primary"
                          >
                            Update
                          </Link>
                        </td>

                        <td>
                          <Button
                            size="sm"
                            variant="info"
                            onClick={() => sendOtp(entry)}
                            disabled={sendingOtpForId === entry.roId}
                          >
                            {sendingOtpForId === entry.roId ? "Sending..." : "Validate by OTP"}
                          </Button>
                        </td>
                      </>
                    ) : null}
                      <td>
                      {entry.dispensers && entry.dispensers.length > 0
                        ? renderTableTooltip(
                          entry.dispensers.map(d => d.dispenserNumber).join(", ")
                        )
                        : "No Dispensers"}
                    </td>

                    <td>{entry.country}</td>
                    <td>{entry.state}</td>
                      <td>{entry.district}</td>
                    <td>{entry.city}</td>
                    {/* <td>{entry.address}</td> */}
                   <td>{renderTableTooltip(entry.address)}</td>


                    <td>{entry.pincode}</td>
                    <td>{entry.roAlternativeEmail}</td>
                   



                    <td>{entry.roAlternativeContact}</td>
                    <td>{entry.roAlternativeContactPerson}</td>
                    {/* <td>{entry.latitude}</td>
                  <td>{entry.longitude}</td> */}
                    <td>{imageFieldFormatter(entry.incorporationCertificate)}</td>
                    <td>{imageFieldFormatter(entry.gstCertificate)}</td>
                    <td>{imageFieldFormatter(entry.panCard)}</td>
                    <td>{imageFieldFormatter(entry.contactAadhar)}</td>
                    <td>{imageFieldFormatter(entry.alternativeContactAadhar)}</td>
                    <td>{entry.createdDate}</td>
                    <td>{entry.updatedDate}</td>
                    <td>{renderTableTooltip(entry.roRemark)}</td>
                    <td>{entry.documentValidatedStatus}</td>
                    <td>{entry.status}</td>
                    <td>{entry.customerName}</td>
                    <td>{entry.roStatus}</td>
                    <td>{entry.createdBy}</td>
                    <td>{entry.updatedBy}</td>
                  
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="28" className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination controls */}
        {filteredEntries.length > rowsPerPage && (
          <div className="d-flex justify-content-center align-items-center my-3">
            <Button
              size="sm"
              variant="secondary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              className="me-3"
            >
              Prev
            </Button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <Button
              size="sm"
              variant="secondary"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              className="ms-3"
            >
              Next
            </Button>
          </div>
        )}
      </Card>

      {/* Image Modal */}
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Document Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedImageUrl ? (
            <img
              src={selectedImageUrl}
              alt="Document"
              style={{ maxWidth: "60%", maxHeight: "70vh" }}
            />
          ) : (
            <p>No Image Available</p>
          )}
        </Modal.Body>
      </Modal>

      {/* OTP Modal */}
      <Modal show={showOtpModal} onHide={() => setShowOtpModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>OTP Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sendingOtpForId === currentEntry?.roId ? (
            <p className="text-info">Please wait, OTP sending in progress...</p>
          ) : (
            <>
              <p>
             OTP will sent to below email and mobile number please enter OTP and verify
                <br />
                <strong>Email:</strong> {currentEntry?.roEmail} <br />
                <strong>Mobile:</strong> {currentEntry?.roContact}
              </p>

              <Form>
                <Form.Group className="mb-3" controlId="smsOtp">
                  <Form.Label>SMS OTP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter SMS OTP"
                    value={smsOtp}
                    onChange={(e) => setSmsOtp(e.target.value)}
                    maxLength={6}
                    autoComplete="off"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="emailOtp">
                  <Form.Label>Email OTP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Email OTP"
                    value={emailOtp}
                    onChange={(e) => setEmailOtp(e.target.value)}
                    maxLength={6}
                    autoComplete="off"
                  />
                </Form.Group>
              </Form>
            </>
          )}

          {otpSendMessage && <p className="text-success">{otpSendMessage}</p>}

          {otpVerifyMessage && (
            <p
              className={
                otpVerified === null
                  ? ""
                  : otpVerified
                    ? "text-success"
                    : "text-danger"
              }
            >
              {otpVerifyMessage}
            </p>
          )}

          <div className="d-flex justify-content-end">
            {/* <Button
              variant="info"
              onClick={triggerOtpSend}
              disabled={sendingOtpForId === currentEntry?.roId}
              className="me-2"
            >
              {sendingOtpForId === currentEntry?.roId ? "Sending..." : "Get OTP"}
            </Button> */}

            <Button
              variant="info"
              onClick={triggerOtpSend}
              disabled={otpDisabled || sendingOtpForId === currentEntry?.roId}
              className="me-2"
            >
              {otpDisabled ? `Resend OTP in ${otpTimer}s` : "Get OTP"}
            </Button>


            <Button
              variant="primary"
              onClick={verifyOtp}
              disabled={otpVerifying}
            >
              {otpVerifying ? "Verifying..." : "Verify OTP"}
            </Button>

            {/* <Button
            variant="danger"
            onClick={() => setShowOtpModal(false)}
            className="me-2"
            disabled={otpVerifying}
          >
            Close
          </Button> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RoOnboardingTable;
